import { createFileRoute } from '@tanstack/react-router'
import { getOrgUsers } from '@/api/org/users'
import { PageContent } from '@/components/PageContent'
import { PageHeader } from '@/components/PageHeader'
import { OrganisationUsersSettings } from '@/features/settings/OrganisationUsersSettings'

export const Route = createFileRoute('/_auth/$orgSlug/users/')({
  loader: async () => ({ users: await getOrgUsers() }),
  component: RouteComponent,
  head: () => ({ meta: [{ title: 'Users - Snowvault' }] })
})

function RouteComponent() {
  const { userOrgProfile } = Route.useRouteContext().user
  const { users } = Route.useLoaderData()

  return (
    <>
      <PageHeader breadcrumbs={[{ label: 'Users' }]} />
      <PageContent>
        <OrganisationUsersSettings users={users} userOrgProfile={userOrgProfile} />
      </PageContent>
    </>
  )
}
